import { SolidifyableData } from "../../../core/data/SolidifyableData";
import { GameConstants } from "../../controller/net/constant/GameConstants";
/**
 * AbstractStakeData.ts
 */
export class AbstractStakeData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.create();
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.maximumPurchaseStake = this.data.getNumber(GameConstants.PROPERTY_MAXIMUM_STAKE);
            this.maximumTotalStake = this.data.getNumber(GameConstants.PROPERTY_MAXIMUM_TOTAL_STAKE);
        }
    }
    create() {
        this.changed = false;
    }
    setIndex(value) {
        this.incremented = value > this.index;
        this.index = value;
    }
    setIndexByAmount(value) {
        for (let i = 0; i < this.amounts.length; i++) {
            if (this.amounts[i] == value) {
                this.setIndex(i);
            }
        }
    }
    setIncremented(value) {
        this.incremented = value;
    }
    setChanged(value) {
        this.changed = value;
    }
    setAmounts(value) {
        this.amounts = value;
    }
    getAmounts() {
        return this.amounts;
    }
    getDefaultIndex() {
        return this.defaultIndex;
    }
    getCurrent() {
        return this.amounts[this.index];
    }
    getIndex() {
        return this.index;
    }
    hasChanged() {
        return this.changed;
    }
    hasIncremented() {
        return this.incremented;
    }
    getMaximumPurchaseStake() {
        return this.maximumPurchaseStake;
    }
    getMaximumTotalStake() {
        return this.maximumTotalStake;
    }
}
//# sourceMappingURL=AbstractStakeData.js.map